import { SHAREHOLDERS_BASE_PATH, SHAREHOLDERS_TAB_SLUGS } from './constants';
import type {
    ShareholdersNavItemType,
    ShareholdersTabSlug,
    ShareholdersTabType,
} from './types';

import { SHAREHOLDERS_SECTION_CONTENT } from '@/static/content/pl/shareholders';

export const isShareholdersTabSlug = (
    value?: string,
): value is ShareholdersTabSlug =>
    SHAREHOLDERS_TAB_SLUGS.some(slug => slug === value);

export const getShareholdersTabPath = (slug: ShareholdersTabSlug) =>
    `${SHAREHOLDERS_BASE_PATH}${slug}/`;

export const getShareholdersArchivePath = () =>
    `${getShareholdersTabPath('walne-zgromadzenia')}archiwum/`;

export const ARCHIVE_TITLE_SUFFIX = ` – ${SHAREHOLDERS_SECTION_CONTENT.meeting.archiveTab}`;
const BRAND_TITLE_SUFFIX = ' | PayPo';

type ShareholdersTabSeoSource = Pick<
    ShareholdersTabType,
    'name' | 'seoTitle' | 'seoDescription'
>;

export const getShareholdersTabSeo = ({
    name,
    seoTitle,
    seoDescription,
}: ShareholdersTabSeoSource) => ({
    title: seoTitle ?? name,
    absoluteTitle: !!seoTitle,
    description: seoDescription ?? SHAREHOLDERS_SECTION_CONTENT.seoDescription,
});

const appendArchiveSuffix = (title: string) =>
    title.endsWith(BRAND_TITLE_SUFFIX)
        ? `${title.slice(0, -BRAND_TITLE_SUFFIX.length)}${ARCHIVE_TITLE_SUFFIX}${BRAND_TITLE_SUFFIX}`
        : `${title}${ARCHIVE_TITLE_SUFFIX}`;

export const getShareholdersArchiveSeo = (tab: ShareholdersTabSeoSource) => {
    const seo = getShareholdersTabSeo(tab);

    return { ...seo, title: appendArchiveSuffix(seo.title) };
};

export const findShareholdersTab = (
    tabs: ShareholdersTabType[],
    slug: ShareholdersTabSlug,
) => tabs.find(tab => tab.slug === slug);

export const mapShareholdersNavItems = (
    tabs: ShareholdersTabType[],
): ShareholdersNavItemType[] =>
    tabs.map(({ slug, name }) => ({
        slug,
        name,
        href: getShareholdersTabPath(slug),
    }));

export const getShareholdersSitemapPaths = (slugs: ShareholdersTabSlug[]) =>
    slugs.flatMap(slug =>
        slug === 'walne-zgromadzenia'
            ? [getShareholdersTabPath(slug), getShareholdersArchivePath()]
            : [getShareholdersTabPath(slug)],
    );
